<template>
  <div>
    <q-dialog
      :visible="isShowAssembly"
      title="组件信息"
      width="60%"
      :innerScroll="false"
      :showFooter="false"
      @close="isShowAssembly = false"
    >   
      <div 
        class="dialogContent" 
        v-if="detail && ((detail.signUpModules && detail.signUpModules.length) || (detail.lotteryModules && detail.lotteryModules.length) || detail.skillDetail || detail.questionBaseDetail || detail.groupBuyingDetailVO || detail.drawDetailVO || detail.countMoneyDetailVO || detail.couponSessions) ">
        <div
          class="information"
          v-for="(item, index) in detail.signUpModules"
          :key="item.activityId"
        >
          <p class="titleStyle">报名组件{{ number_chinese(index + 1) }}</p>
          <el-row>
            <el-col :span="8">
              <span>报名开始时间：</span>
              <span>{{ item.startTime | dateFormat }}</span>
            </el-col>
            <el-col :span="8">
              <span>报名结束时间：</span>
              <span>{{ item.endTime | dateFormat }}</span>
            </el-col>
            <el-col :span="8">
              <span>报名费用：</span>
              <span>{{ item.signUpFee!='0' &&item.signUpFee!=null?item.signUpFee:'免费'}}</span>
            </el-col>
          </el-row>
        </div>
        <div
          class="information"
          v-for="(obj, index) in detail.lotteryModules"
          :key="index"
        >
          <p class="titleStyle">抽奖组件{{ number_chinese(index + 1) }}</p>
          <el-row>
            <el-col :span="8">
              <span>抽奖开始时间：</span>
              <span>{{ obj.startTime | dateFormat }}</span>
            </el-col>
            <el-col :span="8">
              <span>抽奖结束时间：</span>
              <span>{{ obj.endTime | dateFormat }}</span>
            </el-col>
            <el-col :span="8">
              <span>截止兑奖时间：</span>
              <span>{{ obj.exchangeEndDate | dateFormat }}</span>
            </el-col>
            <el-col :span="8" style="margin-top: 15px">
              <span>奖品详情：</span>
              <el-button type="text" size="small" @click="btnLook(obj, 'luckdraw')">
                点击查看
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="information" v-if="detail.skillDetail">
          <p class="titleStyle">秒杀组件</p>
          <el-row>
            <el-col :span="8">
              <span>总商品数：{{detail.skillDetail.goodsCount || 0}}</span>
              <el-button type="text" size="small" @click="btnLook({},'goods')">
                点击查看
              </el-button>
            </el-col>
            <el-col :span="8">
              <span>总场次数：{{detail.skillDetail.sessionsCount || 0}}</span>
              <el-button type="text" size="small" @click="btnLook({},'sessions')">
                点击查看
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="information" v-if="detail.questionBaseDetail">
          <p class="titleStyle">问答组件{{ number_chinese(1) }}</p>
          <el-row>
            <el-col :span="8">
              <span>创建类型：</span>
              <span>{{detail.questionBaseDetail.questionType | questionType}}</span>
            </el-col>
            <el-col :span="8">
              <span>试卷名称：</span>
              <template v-if="detail.questionBaseDetail.templateName">
                <span>{{detail.questionBaseDetail.templateName || ''}}</span>
                <el-button type="text" size="small" @click="btnLook(detail.questionBaseDetail, 'question')">
                  点击查看
                </el-button>
              </template>
              <span v-else>自定义试卷(无法查看)</span>
            </el-col>
            <el-col :span="8">
              <span>答题类型：</span>
              <span>{{detail.questionBaseDetail.answerType | answerType}}</span>
            </el-col>
            <el-col :span="24" style="margin-top: 15px">
              <span>答题分数（每道题）：</span>
              <span>{{detail.questionBaseDetail.scorePerQuestion}}</span>
            </el-col>
          </el-row>
        </div>
        <div class="information" v-if="detail.groupBuyingDetailVO">
          <p class="titleStyle">拼团组件</p>
          <el-row>
            <el-col :span="8">
              <span>总商数量：{{detail.groupBuyingDetailVO.goodsNumber || 0}}</span>
              <el-button type="text" size="small" @click="btnLook({},'groupGoodsNumber')">
                点击查看
              </el-button>
            </el-col>
            <el-col :span="8">
              <span>开团数：{{detail.groupBuyingDetailVO.teamNumber || 0}}</span>
              <el-button type="text" size="small" @click="btnLook({},'groupNumber')">
                点击查看
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="information" v-if="detail.drawDetailVO">
          <p class="titleStyle">求签组件</p>
          <el-row>
            <el-col :span="8">
              <span>签文：{{detail.drawDetailVO.drawNum}}</span>
              <el-button type="text" size="small" @click="btnLook({},'drawLotsSign')">
                点击查看
              </el-button>
            </el-col>
            <el-col :span="8">
              <span>兑换奖品：{{detail.drawDetailVO.prizeNum}}</span>
              <el-button type="text" size="small" @click="btnLook({},'drawLotsDetail')">
                点击查看
              </el-button>
            </el-col>
            <el-col :span="8">
              <span>已兑换奖品：{{detail.drawDetailVO.exchangedPrizeNum}}</span>
              <el-button type="text" size="small" @click="btnLook({},'drawLotsDrawLots')">
                点击查看
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="information" v-if="detail.countMoneyDetailVO">
          <p class="titleStyle">红包挑战赛组件</p>
          <el-row>
            <el-col :span="8">
              <span>挑战开始时间：</span>
              <span>{{ detail.countMoneyDetailVO.startTime | dateFormat }}</span>
            </el-col>
            <el-col :span="8">
              <span>挑战结束时间：</span>
              <span>{{ detail.countMoneyDetailVO.endTime | dateFormat }}</span>
            </el-col>
            <el-col :span="8">
              <span>兑奖截止时间：</span>
              <span>{{ detail.countMoneyDetailVO.exchangeEndDate | dateFormat }}</span>
            </el-col>
            <el-col :span="8" style="margin-top: 15px">
              <span>奖励类型：</span>
              <span>{{  detail.countMoneyDetailVO.rewardMechanism }}</span>
            </el-col>
            <el-col :span="8" style="margin-top: 15px">
              <span>奖品详情：</span>
              <el-button type="text" size="small" @click="btnLook(detail.countMoneyDetailVO, 'countMoneyDetail')">
                点击查看
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="information" v-if="detail.couponSessions.length">
          <p class="titleStyle">优惠券组件</p>
          <el-row v-for="(item, index) in detail.couponSessions" :key="index">
            <el-col :span="8">
              <span>优惠券开始时间：</span>
              <span>{{ item.startTime }}</span>
            </el-col>
            <el-col :span="8">
              <span>优惠券结束时间：</span>
              <span>{{ item.endTime }}</span>
            </el-col>
            <el-col :span="8">
              <span>优惠券数量：</span>
              <span>{{ item.couponNum }}</span>
              <el-button type="text" size="small"  @click="btnLook(item, 'couponDetail')">
                点击查看
              </el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="nullBox" v-else @click="test">暂无数据</div>
      <div style="text-align: center">
        <el-button @click="isShowAssembly = false" size="medium">关 闭</el-button>
      </div>
    </q-dialog>
    <look-dialog ref="lookRef" :detail="detail"/>
  </div>
</template>

<script>
import { number_chinese } from '@/utils/numberChinese'
import lookDialog from './look-dialog.vue';
export default {
  components: {
    lookDialog
  },
  props: {
    isShowCpnsInfoDialog: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    isShowAssembly: {
      get() {
        return this.isShowCpnsInfoDialog
      },
      set(newVal) {
        this.$emit('update:isShowCpnsInfoDialog', newVal)
      }
    }
  },
  data() {
    return {
      number_chinese,
      queryType: '',
      propList: []
    }
  },
  methods: {
    btnLook(item,type) {
      this.$refs.lookRef.init(item,type)
    },
    test() {
      console.log(this.detail)
    }
  },
  filters: {
    questionType(value) {
      return value == 'template' ? '题库' : '自定义'
    },
    answerType(value) {
      return value == 'sequence' ? '固定顺序' : '随机抽题'
    },
  },
}
</script>

<style lang="stylus" scoped>
  .dialogContent {
    max-height: 70vh;
    overflow-y: auto;
    .information {
      margin-bottom: 10px;
      .title {
        font-size: 16px;
        margin-bottom: 10px;
      }
      .titleStyle {
        font-weight: bold;
        font-size: 15px
      }
    }
  }
  .nullBox {
    height: 350px
    text-align: center
    line-height: 350px
  }
</style>